import { ConflictError } from "./conflict-error";

// Thrown when a warehouse zone's follow-up would close the transport chain into a loop — a zone
// naming itself, or A naming B while B's chain leads back to A, at any length.
//
// Delivering a load carrier raises its next transport leg from the destination's follow-up, so a
// loop ends nothing: a box would be carried round it for as long as somebody kept scanning it. The
// database is what refuses the write — `warehouse_zones_follow_up_zone_id_not_self_check` for the
// zone itself, `trigger_assert_warehouse_zone_follow_up_is_acyclic` for every longer loop — and
// this is that refusal with a key the client can show. 409: the zone it names exists and the
// caller may write it, and what makes it a loop is the rest of the chain. The form only keeps a
// zone from naming itself, so the longer loops reach the database and come back through here
// rather than as the failed statement's text.
export class WarehouseZoneFollowUpCycleError extends ConflictError {
	constructor() {
		super("stock.follow_up_zone_cycle");
		this.name = "WarehouseZoneFollowUpCycleError";
	}
}
